import React, { useState } from 'react';
import { SessionListPage } from '@/components/pages/SessionListPage';
import { ChatTurnsPage } from '@/components/pages/ChatTurnsPage';
import type { ChatSessionWithPreviewTurns } from '@/types/backend';

export const ChatsPage: React.FC = () => {
  const [selectedChat, setSelectedChat] = useState<ChatSessionWithPreviewTurns | null>(null);

  const handleSessionSelect = (session: ChatSessionWithPreviewTurns) => {
    console.log('🎯 选择会话:', session.title, session.id);
    setSelectedChat(session);
  };

  const handleBackToList = () => {
    console.log('🔙 返回会话列表');
    setSelectedChat(null);
  };

  return (
    <>
      {selectedChat ? (
        <ChatTurnsPage 
          session={selectedChat} 
          onBack={handleBackToList} 
        />
      ) : (
        <SessionListPage 
          onSessionSelect={handleSessionSelect} 
        />
      )}
    </>
  );
}; 